import * as types from '../constants/actionTypes';

export function toggleMyProjectOpen(projectKey) {
    return { type: types.TOGGLE_MY_PROJECT_OPEN, projectKey };
}
export function toggleOtherProjectOpen(projectKey) {
    return { type: types.TOGGLE_OTHER_PROJECT_OPEN, projectKey };
}
export function toggleMyTaskOpen(projectKey, taskKey) {
    return { type: types.TOGGLE_MY_TASK_OPEN, projectKey, taskKey };
}
export function toggleOtherTaskOpen(projectKey, taskKey) {
  return { type: types.TOGGLE_OTHER_TASK_OPEN, projectKey, taskKey };
}
export function unfoldMyProject(projectKey) {
    return { type: types.UNFOLD_MY_PROJECT, projectKey };
}
export function unfoldOtherProject(projectKey) {
  return { type: types.UNFOLD_OTHER_PROJECT, projectKey };
}
export function unfoldMyTask(projectKey, taskKey) {
    return { type: types.UNFOLD_MY_TASK, projectKey, taskKey };
}
export function unfoldOtherTask(projectKey, taskKey) {
  return { type: types.UNFOLD_OTHER_TASK, projectKey, taskKey };
}
export function foldMyProject(projectKey) {
    return { type: types.FOLD_MY_PROJECT, projectKey };
}
export function foldOtherProject(projectKey) {
  return { type: types.FOLD_OTHER_PROJECT, projectKey };
}
export function foldMyTask(projectKey, taskKey) {
    return { type: types.FOLD_MY_TASK, projectKey, taskKey };
}
export function foldOtherTask(projectKey, taskKey) {
  return { type: types.FOLD_OTHER_TASK, projectKey, taskKey };
}
export function resetMyProjectOpen() {
  return { type: types.RESET_MY_PROJECT_OPEN };
}
export function resetOtherProjectOpen() {
  return { type: types.RESET_OTHER_PROJECT_OPEN };
}
export function resetMyTaskOpen() {
  return { type: types.RESET_MY_TASK_OPEN };
}
export function resetOtherTaskOpen() {
  return { type: types.RESET_OTHER_TASK_OPEN };
}




/** WEBPACK FOOTER **
 ** ./src/app/constants/weekApprovalUiActions.js
 **/